var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "heading border-b border-gray-200" }, [
    _vm.title
      ? _c("h1", { staticClass: "title p-3 text-xl font-bold" }, [
          _vm._v(_vm._s(_vm.title)),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "steps" }, [
      _c(
        "ul",
        {
          staticClass: "nav nav-tabs stepsTabs flex p-3 gap-3",
          attrs: { role: "tablist" },
        },
        _vm._l(_vm.steps, function (step, index) {
          return _c(
            "li",
            {
              key: index,
              staticClass: "nav-item",
              class: {
                "cursor-not-allowed opacity-50":
                  !_vm.isUpdate && index < _vm.currentStep,
              },
              on: {
                click: function ($event) {
                  return _vm.updateCurrentStep(index)
                },
              },
            },
            [
              _c(
                "button",
                {
                  staticClass: "nav-link flex items-center gap-2",
                  class: {
                    active: index === _vm.currentStep,
                    "cursor-not-allowed":
                      !_vm.isUpdate && index < _vm.currentStep,
                    completed: _vm.isCompleted(index),
                  },
                  staticStyle: { cursor: "default !important" },
                },
                [
                  _c(
                    "span",
                    {
                      staticClass:
                        "step-icon flex items-center justify-center w-6 h-6",
                    },
                    [_c("i", { class: step.icon })]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "step-title whitespace-nowrap" }, [
                    _vm._v(_vm._s(step.title)),
                  ]),
                ]
              ),
            ]
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }